<template>
  <div class="slider-controls" :class="{out}">
    <h2 :class="{out}" ref="title">
        <router-link :to="currentSlide.link" v-text="title"/>
    </h2>
    <h4>
        <router-link :to="currentSlide.link" v-text="subTitleText"/>
    </h4>

    <BetButton :to="currentSlide.link"
    class="slider-button"
    text="Ver mais" />

    <SliderButtons :currentSlide="currentSlideIndex"
    :nrOfSlides="posts.length"
    v-if="posts.length > 1"
    @update:currentSlide="$emit('update:currentSlideIndex', $event )" />

  </div>
</template>

<script>
  import BetButton from '@/components/BetButton.vue';
  import SliderButtons from '@/components/Slider/Buttons.vue';

  export default {
    name: 'SlideInfo',
    components: {
      BetButton,
      SliderButtons,
    },
    props: {
      posts: {
        type: Array,
        required: true,
      },
      currentSlideIndex: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        activeSlideIndex: 0,
        nextActiveSlideIndex: 0,
        subTitleLength: 0,
        out: false,
      }
    },
    computed: {
      currentSlide() {
        return this.posts[this.activeSlideIndex];
      },
      title() {
        return this.currentSlide.title.rendered;
      },
      subTitle() {
        return this.currentSlide.fields.subtitle;
      },
      subTitleText() {
        return this.subTitle.substring(0, this.subTitleLength);
      },
    },
    watch: {
      currentSlideIndex: {
        immediate: false,
        async handler() {
          this.out = true;
          this.nextActiveSlideIndex = this.currentSlideIndex;
          while(this.subTitleLength > 0) {
            await new Promise(resolve => setTimeout(resolve, 1));
            await this.$nextTick();
            this.subTitleLength -= 1;
          }
        },
      },
      subTitle: {
        immediate: true,
        async handler() {
          while(this.subTitleLength < this.title.length) {
            await new Promise(resolve => setTimeout(resolve, 5));
            await this.$nextTick();
            this.subTitleLength += 1;
          }
        }
      },
    },
    mounted() {
      this.$refs.title.addEventListener('animationend', () => {
        this.activeSlideIndex = this.nextActiveSlideIndex;
        this.out = false;
      });
    }}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/queries";
@import "@/assets/scss/colors";
@import "@/assets/scss/fonts";

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translateX(10px);
  }
}

.slider-controls {
  --slider-button-margin: auto 0;
  --slider-subtitle-size: 1.5rem;
  --slider-title-size: 1.5rem;
  --slider-title-width: 100%;

  @include media(sm) {
    --slider-button-margin: calc(var(--content-width) * 0.0125) 0;
    --slider-subtitle-size: calc(var(--content-width) * .011);
    --slider-title-size: calc(var(--content-width) * .0325);
    --slider-title-width: calc(var(--content-width) * .45);
  }

  position: absolute;
  margin: 0 auto;
  padding: 0 30px;
  z-index: 15;
  left: 0;
  bottom: 0;
  top: calc(var(--menu-padding) * 4);

  width: var(--slider-title-width);

  @include media(sm, true) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @include media(sm) {
    top: calc(var(--content-width) * .15);
    left: calc(var(--side-padding) + var(--content-inner-padding));
    height: fit-content;
  }

  a {
      text-decoration: none;
      color: $color-white;
  }

  h2 {
    // Layout
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    width: 100%;
    // Typography
    color: #FFF;
    font-family: $ff-headings;
    font-weight: 900;
    line-height: 1;
    text-transform: uppercase;
    animation: fade-in .75s ease-in-out;

    margin: 0;

    font-size: var(--slider-title-size);

    @include media(sm, true) {
      text-align: center;
    }

    &.out {
      animation: fade-out .5s ease-in-out forwards;
    }
  }

  h4 {
    color: #FFF;
    font-family: Glober;
    line-height: 1em;
    font-style: italic;
    font-weight: 400;
    line-height: 1;
    text-transform: uppercase;
    display: block;
    height: 2.5em;

    @include media(sm, true) {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @include media(sm) {
      font-size: var(--slider-subtitle-size);
      height: 0.9375rem;
    }
  }

  .slider-button {
    margin: var(--slider-button-margin);
  }

  $slider-control-padding-top: .5rem;
  $slider-control-padding-bottom: .5rem;

  .slider-buttons {
    display: flex;
    align-items: center;
    margin-top: (1.88rem - $slider-control-padding-top);
    gap: 10px;
  }

  .slider-control {
    width: 37px;
    height: ($slider-control-padding-top + 0.25rem + $slider-control-padding-bottom);
    // background: $color-betano;
    background-image: linear-gradient(
      180deg,
      rgba($color-betano, 0) $slider-control-padding-top,
      $color-betano $slider-control-padding-top,
      $color-betano ($slider-control-padding-top + 0.25rem),
      rgba($color-betano, 0) ($slider-control-padding-top + 0.25rem)
      );
    margin-bottom: -$slider-control-padding-bottom;
    cursor: pointer;
    &:not(.active) {
      opacity: 0.5;
    }
  }
}
</style>
